import { render, staticRenderFns } from "./Simulacao.vue?vue&type=template&id=493a00c6&"
import script from "./Simulacao.vue?vue&type=script&lang=js&"
export * from "./Simulacao.vue?vue&type=script&lang=js&"
import style0 from "./Simulacao.vue?vue&type=style&index=0&id=493a00c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports